<template>
  <div>
    <div class="faq-question">
      <button
      class="btn btn__first"
      @click="arrowDown = !arrowDown, show = !show, enviaGA()"
      >
      Considerações importantes sobre o cálculo para tirar CNPJ
      </button>
      <Icone class="icon-arrow" :cor="corTexto">{{ this.arrowDown ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</Icone>
    </div>

    <div class="block collapsee first" :class="{'showw': show}">
      <div class="block__content">
        <p>Os cálculos são baseados em empresas enquadradas no regime tributário
          Simples Nacional e natureza jurídica do tipo Empresa Individual.
          Algumas modalidades de empresa também necessitam de um capital social para sua abertura, seja esse valor em dinheiro ou em bens e equipamentos.</p>

        <p>A taxa de registro público mencionada no cálculo é referente a DARE,
          Documento de Arrecadação de Receitas Estaduais, valor da Junta Comercial.</p>

        <p>O certificado digital é necessário para confirmar a autencidade de
          empresas que emitem notas fiscais eletrônicas.</p>

        <p>Além dos valores apresentados, poderão haver outros custos,
          a depender da atividade exercida pela empresa e do município onde ela estará localizada, tais como: alvará de funcionamento, laudo técnico gerado por um arquiteto,
          laudo da vigilância sanitária, alvará do corpo de bombeiros e licença ambiental, por exemplo.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icone from '@/components/Icone';

export default {
  name: 'ListaCollapseFaq',
  components: {
    Icone
  },
  props: {
    itens: {
      type: Array,
      default: () => ([{
        titulo: '',
        descricao: ''
      }])
    },
    desabilitarTrackNativo: {
      type: Boolean,
      default: false
    },
    corTexto: {
      type: String,
      default: ''
    },
    corDescricao: {
      type: String,
      default: ''
    },
    linkDesign: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      listaFlechas: [],
      arrowDown: true,
      show: false,
    }
  },
  methods: {
    enviaGA() {
      if(this.show === true){
        const pathLocation = window.location.pathname.replaceAll("/", "")
        dataLayer.push({
          event: 'customEvent',
          eventCategory: `blog: ${pathLocation}`,
          eventAction: 'dropdown:calculadora-custo-cnpj',
          eventLabel: `consideracoes-importantes`
        })
      }
    },
  },
  computed: {
    colorAnswer() {
      return this.corDescricao === 'white' || this.corDescricao === '#fff'
    }
  },
}
</script>

<style lang="scss" scoped>
  $dark-blue: #00919d;
  $dark-neutral: #30455c;
  .faq-question {
    position: relative;
    margin-top: 20px;
  }
  .btn {
    color: $dark-neutral;
    font-size: 16px;
    width: 100%;
    background: #fff;
    border: 0;
    display: flex;
    padding: 8px 17px;
    cursor: pointer;
  }
  .icon-arrow {
    font-family: 'Material Symbols Outlined', sans-serif;
    position: absolute;
    top: 12px;
    right: 5px;
  }
  .collapsee {
    display: block;
    max-height: 0px;
    overflow: hidden;
    transition: max-height .5s cubic-bezier(0, 1, 0, 1);
    &.showw {
      max-height: 99em;
      transition: max-height .5s ease-in-out;
    }
  }
  .block {
    margin-top: 10px;
    background: #fff;
    padding: 0;
    &__content {
      border: 1px solid #fff;
      padding: 1.5em;
      height: 100%;
      display: flex;
      flex-direction: column;
      text-align: left;
    }
  }
</style>
